import { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Calling from './api/Calling';
import ClientApp from './client/ClientApp';
import { ToastContainer } from 'react-toastify';
import Navbar1 from './components/Navbar/Navbar1';
import Navbar2 from './components/Navbar/Navbar2';
import Login from './admin/Login/Login';
import Page404 from './components/page/Page404';
import Logout from './admin/Login/Logout';
import Error from './admin/Login/Error';
import Home from './admin/Home';
import NewPw from './admin/Login/NewPw';
import ForgetPw from './admin/Login/ForgetPw';
import ForgetPwOtp from './admin/Login/ForgetPwOtp';
import LoginOtp from './admin/Login/LoginOtp';
import Profile from './admin/Profile/Profile';
import UserAll from './admin/User/UserAll';
import UserInfo from './admin/User/UserInfo';
import UserLogin from './admin/User/UserLogin';
import Question from './admin/Question/Question';
import QuestionShow from './admin/Question/QuestionShow';
import QuizAdd from './admin/Quiz/QuizAdd';
import QuizShow from './admin/Quiz/QuizShow';
import QuizView from './admin/Quiz/QuizView';
import Terms from './admin/Policy/Terms';
import Policy from './admin/Policy/Policy';
import Quizleaderboard from './admin/Quiz/Quizleaderboard';
import LeaderBoard from './admin/LeaderBoard/LeaderBord';
import UserDelete from './admin/User/UserDelete';
import DeleteUserPage from './admin/DeleteUserPage';
import ContactOptions from './admin/Contact/ContactOptions';
import UserContact from './admin/Contact/UserContact';
import Notification from './admin/Controller/Notification';
import Controller from './admin/Controller/Controller';
import NativeAds from './admin/Ads/NavtiveAds/NativeAds';
import FullScreenAds from './admin/Ads/FullScreenAds/FullScreenAds';
import BannerAds from './admin/Ads/BannerAds/BannerAds';
import RewardAds from './admin/Ads/RewardAds/RewardAds';
import OpenAds from './admin/Ads/OpenAds/OpenAds';
import WithdrawCoupon from './admin/Withdraw/WithdrawCoupon';
import WithdrawReq from './admin/Withdraw/WithdrawReq';
import INSPACTLOOCK from './components/INSPACTLOOCK';
import ContactUs from './admin/Policy/ContactUs';
import GuideVideo from './admin/Controller/GuideVideo';
import Rules from './admin/Quiz/Rules';
import DailyWatchAd from './admin/Other/DailyWatchAd/DailyWatchAd';
import ReadAndEarn from './admin/Other/DailyWatchAd/ReadAndEarn';
import WinBar from './admin/Controller/WinBar';
import QuizNonStop from './admin/Quiz/QuizNonStop';
import AllChat from './admin/Other/ChatSupport/AllChat';
import ChatRead from './admin/Other/ChatSupport/ChatRead';
import TapToEarn from './admin/Other/DailyWatchAd/TapToEarn';
import QuizWrong from './admin/Quiz/QuizWrong';
import Whois from './admin/Other/DailyWatchAd/Whois';

import EditeInHouseAds from './admin/Ads/InHouseAds/EditeInHouseAds';
import InHouseAds from './admin/Ads/InHouseAds/InHouseAds';
import ViewsDashbord from './admin/ViewsDashbord';
import AdsEarn from './admin/Other/DailyWatchAd/AdsEarn';
import InhouseDashboard from './admin/Ads/InHouseAds/InhouseDashboard';
import UserCome from './admin/User/UserCome';
import Game from './admin/Game/Game';
import CoinNotification from './admin/Controller/CoinNotification';
import Reels from './admin/Other/Reels/Reels';
import ReelsSetting from './admin/Other/Reels/ReelsSetting';

function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem('admin_quiz_app');
    navigate('/admin/panel/login');
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem('admin_quiz_app');

        if (!adminToken) {
          setIsAuthorized(false);
          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  // ── Keep the admin panel OUT of search engines (it's private) ──
  // Inject <meta name="robots" content="noindex,nofollow"> on every admin
  // page (login + dashboard). Public client routes stay fully indexable.
  useEffect(() => {
    const p = location.pathname;
    const isAdminShell =
      p.startsWith('/admin') || p.startsWith('/web/delete') || Boolean(isAuthorized);

    let meta = document.querySelector('meta[name="robots"]');
    if (isAdminShell) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'robots');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', 'noindex, nofollow');
    } else if (meta) {
      // Public route → make sure no leftover noindex blocks indexing
      meta.remove();
    }
  }, [location.pathname, isAuthorized]);

  // ── Public client (quizzyloot.com) ──
  // Non-admin visitors get the public quiz site, rendered FULL-SCREEN and
  // completely outside the admin chrome (no admin navbars/layout/styles).
  // Admin area (/admin/*, /web/delete/*) and logged-in admins fall through
  // to the untouched admin shell below.
  const path = location.pathname;
  const isAdminArea =
    path.startsWith('/admin') || path.startsWith('/web/delete');
  if (!isAdminArea && !isAuthorized) {
    return <ClientApp />;
  }

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <INSPACTLOOCK />
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/Logout" element={<Logout onLogout={handleLogout} />} />
              <Route path='/profile' element={<Profile />} />

              {/* User */}
              <Route path='/manage/user/all/data' element={<UserAll />} />
              <Route path='/manage/user/all/info/:id' element={<UserInfo />} />

              {/* User Login */}
              <Route path='/manage/user/login/all/data' element={<UserLogin />} />

              {/* User Delete Req */}
              <Route path='/manage/user/all/delete/req' element={<UserDelete />} />
              {/* User Delete Req */}
              <Route path='/manage/user/comeback' element={<UserCome />} />

              {/*Question */}
              <Route path='/manage/question' element={<Question />} />
              <Route path='/manage/question/show' element={<QuestionShow />} />

              {/* Game Module */}
              <Route path='/manage/game/all' element={<Game />} />

              {/* Reels */}
              <Route path='/manage/reels' element={<Reels />} />
              <Route path='/manage/reels/setting' element={<ReelsSetting />} />

              {/* Contact Us */}
              <Route path='/manage/contact/message' element={<UserContact />} />
              <Route path='/manage/contact' element={<ContactOptions />} />
              <Route path='/manage/contact/chat' element={<AllChat />} />
              <Route path='/manage/contact/chat/read' element={<ChatRead />} />

              {/*Quiz */}
              <Route path='/manage/quiz/add' element={<QuizAdd />} />
              <Route path='/manage/quiz/show' element={<QuizShow />} />
              <Route path='/manage/quiz/view/:id' element={<QuizView />} />
              <Route path='/manage/quiz/leaderboard/:id' element={<Quizleaderboard />} />

              <Route path='/manage/quiz/nonstop' element={<QuizNonStop />} />
              <Route path='/manage/quiz/wrong' element={<QuizWrong />} />

              {/* Withdraw  */}
              <Route path='/manage/withdraw/coupon' element={<WithdrawCoupon />} />
              <Route path='/manage/withdraw/request' element={<WithdrawReq />} />


              {/* Daily Watch Ads Earn */}
              <Route path='/manage/quiz/daily/streak/earn' element={<DailyWatchAd />} />
              <Route path='/manage/quiz/read/earn' element={<ReadAndEarn />} />
              <Route path='/manage/quiz/tap/earn' element={<TapToEarn />} />
              <Route path='/manage/quiz/whois/earn' element={<Whois />} />
              <Route path='/manage/quiz/ad/earn' element={<AdsEarn />} />


              {/* Main Leaderboard */}
              <Route path='/main/leaderboards' element={<LeaderBoard />} />

              {/* Controller */}
              <Route path='/controller' element={<Controller />} />

              {/* Notifications */}
              <Route path='/notification' element={<Notification />} />

              {/* Coin Notifications */}
              <Route path='/coin/notification' element={<CoinNotification />} />

              {/* Native Ads */}
              <Route path='/manage/ads/nativeAds/add' element={<NativeAds />} />

              {/* FullScreenAds */}
              <Route path='/manage/ads/fullScreenAds/add' element={<FullScreenAds />} />

              {/* Banner Ads */}
              <Route path='/manage/ads/bannerAds/add' element={<BannerAds />} />

              {/* Open Ads */}
              <Route path='/manage/ads/openAds/add' element={<OpenAds />} />

              {/* Win Bar */}
              <Route path='/manage/winbar' element={<WinBar />} />

              {/* Reward Ads */}
              <Route path='/manage/ads/rewardAds/add' element={<RewardAds />} />

              {/* InHouseAds */}
              <Route path='/manage/ads/inHouseAds/add' element={<InHouseAds />} />
              <Route path='/manage/ads/inHouseAds/edit/:id' element={<EditeInHouseAds />} />
              <Route path='/manage/ads/inHouseAds/show' element={<InhouseDashboard />} />

              {/* Views Dashbord */}
              <Route path='/views/dashboard/:id' element={<ViewsDashbord />} />

              {/* Policy */}
              <Route path='/policy' element={<Policy />} />
              <Route path='/policy/terms' element={<Terms />} />
              <Route path='/policy/contactus' element={<ContactUs />} />

              {/* Gaid Video */}
              <Route path='/guide/video' element={<GuideVideo />} />

              {/* Rules Genrator */}
              <Route path='/rules' element={<Rules />} />
              <Route path="*" element={<Error />} />
            </>
          ) : (
            <>
              <Route path='/admin/panel/login' element={<Login />} />
              <Route path='/admin/panel/login/otp' element={<LoginOtp onLogin={handleLoginStatusChange} />} />
              <Route path='/admin/panel/forgetpw' element={<ForgetPw />} />
              <Route path='/admin/panel/forget/otp' element={<ForgetPwOtp />} />
              <Route path='/admin/panel/new/password' element={<NewPw />} />
              <Route path='/web/delete/user' element={<DeleteUserPage />} />
              <Route path='*' element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
